import axios from "@/api/axiosInstance";

export function fetchFlexiFund() {
  return axios.get(`/api/v1/wallets/flexiFund`);
}

export function fetchTextPay() {
  return axios.get(`/api/v1/wallets/textPay`);
}

export function fetchQuickSwap() {
  return axios.get(`/api/v1/wallets/quickSwap`);
}

export function fetchShareGain() {
  return axios.get(`/api/v1/wallets/shareGain`);
}
